import { fetchWithAuth } from '../auth/authService';

const MENU_ENDPOINTS = {
  SIDEBAR: '/api/menu/sidebar',
};

export const getSidebarMenusService = async () => {
  const response = await fetchWithAuth(MENU_ENDPOINTS.SIDEBAR, {
    method: 'GET',
  });
  return response;
};
